<template>
  <a :href="prakerjaBukabantuanLink" class="bukabantuan-faq" rel="nofollow" data-testid="prakerja-bukabantuan">
    <BlIconAv name="ico_comment_minor" color="#2E2E2E" class="ico_comment_minor" />
    <div>
      <p class="mb-8 bl-text--body-16 bl-text bl-text--bold">Live chat</p>
      <p class="bl-text--body-14 bl-text">Chat langsung dengan CS kami</p>
    </div>
  </a>
</template>

<script>
import {BlIconAv} from '@bukalapak/bazaar-visual';

export default {
  name: 'PrakerjaBukabantuan',
  components: {
    BlIconAv,
  },
  data() {
    return {
      prakerjaBukabantuanLink:
        'https://bukabantuan.bukalapak.com/transactions/buyer?category_type=invoice&category_id=1258&complaint_channel=livechat',
    };
  },
};
</script>

<style scoped>
.bukabantuan-faq {
  display: flex;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  text-decoration: none;
  padding: 16px;
  gap: 12px;
  color: #141414;
}
.ico_comment_minor {
  height: 24px !important;
  width: 24px !important;
}
</style>
